import { useEffect } from 'react';
import { useLang } from '../context/LanguageContext';

export default function SEO() {
  const { lang } = useLang();

  useEffect(() => {
    // Update meta tags
    const metaTags = {
      'og:title': lang === 'ru' ? 'KidsMafia - Франшиза семейного event-пространства' : 'KidsMafia - Franquicia de espacio de eventos familiar',
      'og:description': lang === 'ru' 
        ? 'Стабильная модель бизнеса семейных мероприятий. Международная франшиза с прозрачной экономикой. Инвестиции от 150,000 €.'
        : 'Modelo de negocio estable de eventos familiares. Franquicia internacional con economía transparente. Inversión desde 150.000 €.',
      'og:image': window.location.origin + '/img/logo.png',
      'og:url': window.location.href,
      'og:type': 'website',
      'description': lang === 'ru'
        ? 'Франшиза KidsMafia - семейное event-пространство полного цикла. Детский парк, ресторан, event-зона, профессиональная анимация. Инвестиции от 150,000 €.'
        : 'Franquicia KidsMafia - espacio de eventos familiar de ciclo completo. Parque infantil, restaurante, zona de eventos, animación profesional. Inversión desde 150.000 €.',
      'keywords': lang === 'ru'
        ? 'франшиза, детский парк, event-пространство, международный бизнес, KidsMafia, детские праздники, семейный бизнес'
        : 'franquicia, parque infantil, espacio de eventos, negocio internacional, KidsMafia, fiestas infantiles, negocio familiar'
    };

    Object.entries(metaTags).forEach(([property, content]) => {
      let selector = property.startsWith('og:') ? `meta[property="${property}"]` : `meta[name="${property}"]`;
      let meta = document.querySelector(selector);
      
      if (meta) {
        meta.setAttribute('content', content);
      } else {
        meta = document.createElement('meta');
        if (property.startsWith('og:')) {
          meta.setAttribute('property', property);
        } else {
          meta.setAttribute('name', property);
        }
        meta.setAttribute('content', content);
        document.head.appendChild(meta);
      }
    });

    // Add structured data for Organization
    const structuredData = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'KIDS MAFIA SL',
      legalName: 'KIDS MAFIA SL',
      url: window.location.origin,
      logo: window.location.origin + '/img/logo.png',
      description: lang === 'ru'
        ? 'Франшиза семейного event-пространства KidsMafia'
        : 'Franquicia de espacio de eventos familiar KidsMafia',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Calle Puebla de Valverde 4',
        addressLocality: 'Valencia',
        postalCode: '46014',
        addressCountry: 'ES'
      },
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+34-624-586-917',
        email: 'kidsmafia.vlc@gmail.com',
        contactType: 'Customer Service',
        availableLanguage: ['Spanish', 'Russian', 'English']
      },
      sameAs: [
        'https://t.me/SerjValencia'
      ]
    };

    // Remove existing structured data if any
    const existingScript = document.querySelector('script[type="application/ld+json"]');
    if (existingScript) {
      existingScript.remove();
    }

    // Add new structured data
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structuredData);
    document.head.appendChild(script);

    // Update page title
    document.title = lang === 'ru' 
      ? 'KidsMafia - Франшиза семейного event-пространства | Международная франшиза'
      : 'KidsMafia - Franquicia de espacio de eventos familiar | Franquicia internacional';

  }, [lang]);

  return null;
}
